export default function toPounds(price) {
    return (price/100).toFixed(2);
}


/** WEBPACK FOOTER **
 ** ./src/helpers/price.js
 **/